import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteStageSchedule } from "@/adapters/api";

export function useDeleteSchedule(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (stageId: string) => {
			if (!constructionId) throw new Error("missing construction");
			return deleteStageSchedule(constructionId, stageId);
		},
		onSuccess: (_result, stageId) => {
			queryClient.invalidateQueries({
				queryKey: ["schedules", constructionId],
			});
			queryClient.invalidateQueries({
				queryKey: ["schedule", constructionId, stageId],
			});
		},
	});
}
